import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import Loader from 'react-loader-spinner';
import clsx from 'clsx';
import { MainButton } from '../MainButtons/MainButton';

interface Iprops {
  search?: (
    e: string,
    prevRequestController: AbortController | undefined,
  ) => void;
  isLoading?: boolean;
  showRightMenu?: () => void;
  hasNew?: boolean;
  disableButton?: boolean;
  isCreating?: boolean;
  canCreate?: boolean;
  placeHolder?: string;
  containerBackground?: string;
  inputColor?: string;
  iconColor?: string;
  rigthElement?: boolean;
  filter?: JSX.Element;
  additionalContent?: JSX.Element;
  searchText?: string;
}

let prevRequestController: AbortController;

export const Search: React.FC<Iprops> = ({
  search,
  isLoading,
  showRightMenu,
  hasNew,
  isCreating,
  canCreate = true,
  disableButton,
  placeHolder,
  containerBackground,
  rigthElement,
  filter,
  inputColor,
  iconColor,
  searchText = '',
  additionalContent,
}: Iprops) => {
  const [isTyping, setTyping] = useState(false);
  const { t } = useTranslation();

  const inputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (prevRequestController) prevRequestController.abort();
    prevRequestController = new AbortController();
    if (!event.target.value && search) {
      search('', prevRequestController);
    } else if (search) {
      search(event.target.value, prevRequestController);
    }
  };

  const debouncedEventHandler = useMemo(() => debounce(inputHandler, 500), []);

  const onfocus = () => {
    setTyping(true);
  };

  const onblur = () => {
    setTyping(false);
  };

  useEffect(
    () => () => {
      debouncedEventHandler.cancel();
    },
    [],
  );

  return (
    <div
      style={{ backgroundColor: containerBackground }}
      className={clsx('rounded-[0.625rem] flex justify-between items-center ', {
        '': !containerBackground,
      })}
    >
      <div
        className={`flex items-center flex-grow-1 w-full ${
          rigthElement ? 'mr-0 ' : 'mr-2'
        }`}
      >
        <div className="flex items-center w-full">
          <span
            className={clsx(
              `${
                iconColor || 'bg-white text-neutral-12'
              } rounded-l-[0.625rem] h-10 border-none flex items-center py-1.5 px-3 text-base`,
            )}
          >
            <span className="icon-search icon text-[#c1c5c9] text-xl rotate-[5] " />
          </span>
          <input
            className={clsx(
              ` ${
                inputColor || 'bg-white  text-[#212529] '
              }ml-[-1px] outline-none  py-1.5 px-3 flex-grow flex-shrink basis-auto  rounded-l-none border-none w-full h-10 rounded-r-[0.625rem]`,
            )}
            aria-label="Search"
            type="text"
            placeholder={placeHolder}
            onFocus={onfocus}
            onBlur={onblur}
            onChange={debouncedEventHandler}
            disabled={!navigator.onLine}
            defaultValue={searchText}
          />
          {isLoading ? (
            <div className="rounded-[0.625rem] bg-[#F2F3F3]  h-10 flex flex-row justify-center items-center p-2.5 ">
              <Loader type="ThreeDots" color="#C1C5C9" height={25} width={30} />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {filter && filter}
      {canCreate && hasNew && (
        <MainButton
          description={t('button.new')}
          type="button"
          icon={<span className={`icon icon-plus text-[25px] `} />}
          position="start"
          disabled={isCreating || disableButton}
          onClick={() => showRightMenu?.()}
        />
      )}
      {additionalContent && additionalContent}
    </div>
  );
};

Search.defaultProps = {
  showRightMenu: () => ({}),
  search: undefined,
  isLoading: false,
  hasNew: false,
  isCreating: false,
  placeHolder: '',
};

export default Search;
